import React, { useState } from 'react';
import MeQrService from '../../../Components/MeQrGenerator/SmartConnectQRMeQr';
import './smartConnectQR.css';

const SmartConnectQR = ({ nombreURL }) => {
  const [qrUrl, setQrUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = "377045a9fb7193f65bbc7b747a903720b3f3ed763f1ae9bfe308f08430a0db35";

  const generarQR = async () => {
    setLoading(true);
    try {
      const url = await MeQrService.generarQR({ nombreURL, token });
      setQrUrl(url);
    } catch (error) {
      console.error(error);
      alert("No se pudo generar el QR");
    }
    setLoading(false);
  };

  return (
    <div className="smartconnect-container">
      <h2>🔗 Genera tu QR Smart-Connect</h2>
      <button className="btn generar" onClick={generarQR} disabled={loading}>
        {loading ? "Generando..." : "🎯 Generar QR"}
      </button>

      {qrUrl && (
        <div className="qr-result">
          <img src={qrUrl} alt="QR generado" />
          <div className="smartconnect-buttons">
            <a href={qrUrl} download={`QR_${nombreURL}.png`}>
              <button className="btn descargar">📥 Descargar QR</button>
            </a>
            <a href={`https://smart-connect.laofi.work/${nombreURL}`} target="_blank" rel="noopener noreferrer">
              <button className="btn visitar">🌐 Ver Perfil</button>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default SmartConnectQR;